import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import type {
  IForgotPasswordEnterSchema,
} from '../types';
import {
  FORGOT_PASSWORD_ENTER_MUTATION_KEY,
  FORGOT_PASSWORD_ENTER_URL,
} from '../constants';

export default function useForgotPasswordEnterMutation(): IContextMutationResult<void, Error, IForgotPasswordEnterSchema> {
  const { fetchPut } = useRestClient();

  return useContextMutation<void, Error, IForgotPasswordEnterSchema>({
    mutationKey: [FORGOT_PASSWORD_ENTER_MUTATION_KEY],
    mutationFn: (payload) => fetchPut<void>(FORGOT_PASSWORD_ENTER_URL, payload),
  });
}
